    $(document).ready(function() {
      var $slidesContainer = $('.slides-container');

      $slidesContainer.each(function(key, item ){
        var sliderIdName = this.id,
            selector = "#" + sliderIdName + " .single-item";

            $(selector).slick({
                infinite: true,
                initialSlide: 0,
                arrows: true,
                dots: false,
                responsive: [{
                    breakpoint: 1090,
                    settings: {
                        arrows: false,
                      	speed: 250,
                        dots: true
                    }
                }]
            });
      });
    });

$(document).ready(function(){
  $('.doubleslick').slick({
  slidesToShow: 5,
  slidesToScroll: 2,
  draggable: true,
    responsive: [{
      breakpoint: 1090,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 2
      }
    }]
  });
});

$(document).ready(function(){
  $('.storyslick').slick({
  slidesToShow: 4,
  slidesToScroll: 2,
  draggable: true,
    responsive: [{
      breakpoint: 1000,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 2
      }
    }]
  });
});

